export const fuseDefaults = {
    shouldSort: true,
    threshold: 0.4,
    location: 0,
    distance: 100,
    maxPatternLength: 12,
    minMatchCharLength: 1,
}
